import React, { useState } from "react";
import { RiLayoutGridFill } from "react-icons/ri";
import { IoListOutline } from "react-icons/io5";
import palette from '../../utils/colorPalette';


const ToggleSwitch = ({ onToggle }) => {
  const [activeView, setActiveView] = useState("List"); // 기본 활성화 상태는 List

  const handleToggle = (view) => {
    setActiveView(view);
    onToggle && onToggle(view); // onToggle 콜백이 있으면 호출
  };

  // 인라인 스타일 정의
  const containerStyle = {
    display: "flex",
    backgroundColor: "#f1f1f1",
    borderRadius: "20px",
    padding: "5px",
    width: "fit-content",
  };

  const buttonStyle = (isActive) => ({
    border: "none",
    background: isActive ? "white" : "none",
    padding: "5px 10px",
    borderRadius: "15px",
    cursor: "pointer",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    color: isActive ? palette.button.primary : "#888",
    transition: "background-color 0.3s, color 0.3s",
  });

  return (
    <div style={containerStyle}>
      <button
        style={buttonStyle(activeView === "List")}
        onClick={() => handleToggle("List")}
      >
        <IoListOutline /> List
      </button>
      <button
        style={buttonStyle(activeView === "Card")}
        onClick={() => handleToggle("Card")}
      >
        <RiLayoutGridFill /> Card
      </button>
    </div>
  );
};

export default ToggleSwitch;
